import React, { useState, useEffect } from "react";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import config from "../api/config";
import TariffCard from "../components/TariffCard/TariffCard";
import Alert from "../components/alert";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import AlertTitle from "@mui/material/AlertTitle";
import DialogTitle from "@mui/material/DialogTitle";
import { setToast } from "../redux/actions/ToastAction";
import { Skeleton } from "@mui/material";
import { useHistory } from "react-router-dom";
import { setUser } from "../redux/actions/AuthAction";

const Tarif = () => {
  const navigate = useHistory();

  // redux
  const currTarif = useSelector(
    (state) =>
      state.reducer.user ? state.reducer.user?.resAdvertisingTariff : {},
    shallowEqual
  );

  const dispatch = useDispatch();
  // variables
  const [loading, setLoading] = useState(false);
  const [allTariffs, setAllTariffs] = useState(null);
  const [modal, setModal] = useState(false);
  const [tariffID, setTariffID] = useState(null);
  const [errBool, setErrBool] = useState(false);
  const [tariffName, setTariffName] = useState("");
  // get all tariffs
  const refresher = async (bool) => {
    if (bool) {
      setLoading(true);
      await config
        .get(`/api/advertisingTariff/v1`)
        .then((data) => {
          setLoading(false);
          setAllTariffs(
            data.data.objectKoinot.sort((a, b) =>
              a.countKey > b.countKey ? 1 : -1
            )
          );
        })
        .catch((err) => console.error(err?.message));
    }
  };
  useEffect(() => {
    refresher(true);
  }, []);
  // open modal
  const handleBuy = async (id, name) => {
    setTariffName(name);
    setTariffID(id);
    setModal(true);
  };
  // buying tariff
  const buyTariff = async () => {
    setLoading(true);
    try {
      const res = await config.post(
        `/api/advertisingTariff/v1/buy/${tariffID}`,
        tariffID
      );
      setLoading(false);
      refresher(true);
      if (res?.data.success === 200) {
        await config
          .get("/api/auth/v1/me")
          .then((data) => dispatch(setUser(data.data.objectKoinot)));
        navigate.push("/");
      } else {
        setErrBool(true);
      }
    } catch (err) {
      dispatch(setToast(true, "error", err.message));
      setLoading(false);
    }
  };
  return (
    <div>
      <Dialog
        open={modal}
        onClose={() => {
          setModal(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Внимание</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Вы действительно хотите купить {tariffName}?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setModal(false);
            }}
          >
            нет
          </Button>
          <Button
            onClick={() => {
              setModal(false);
              buyTariff();
            }}
            autoFocus
          >
            да
          </Button>
        </DialogActions>
      </Dialog>
      <p>
        Эти цены основаны на ключевых словах. Выберите, сколько ключевых слов вы
        хотите использовать в своем почтовом объявлении из этих удобных для вас
        тарифов.
      </p>
      {currTarif?.name ? (
        <>
          <h1 style={{ margin: 0 }}>Ваш текущий тариф</h1>
          <div className="row">
            <div className="col-lg-3 col-md-12">
              <TariffCard
                name={currTarif.name}
                keywords={currTarif.countKey}
                price={null}
                bought={true}
                date={currTarif.countDay}
              />
            </div>
          </div>
        </>
      ) : (
        <Alert severity="error" className="my-3">
          <AlertTitle>Вы еще не выбрали тариф</AlertTitle>
          Необходимо выбрать один из тарифов для размещения объявлений
        </Alert>
      )}
      {errBool ? (
        <Alert severity="warning" className="my-3">
          <AlertTitle>У вас недостаточно денег для покупки Тарифа</AlertTitle>
          Свяжитесь с
          <a
            href="http://t.me/koinot_admin"
            target="_blank"
            className="text-info mx-2"
            rel="noopener noreferrer"
          >
            администратором
          </a>
          для вывода денег на ваш счет
        </Alert>
      ) : null}

      <h1 className="my-3">Все тарифы</h1>

      <div className="row">
        {!loading && allTariffs !== null ? (
          allTariffs.map(
            (v, i) =>
              v.active && (
                <div className="col-lg-3 col-sm-6">
                  <TariffCard
                    key={i}
                    name={v.name}
                    keywords={v.countKey}
                    date={v.countDay}
                    price={v.price}
                    onClick={() => handleBuy(v.id, v.name)}
                  />
                </div>
              )
          )
        ) : (
          <div className="row mb-5">
            <div className="col-md-3 col-sm-6">
              <Skeleton
                variant="rectangular"
                width={"100%"}
                height={200}
                animation="wave"
              />
            </div>
            <div className="col-md-3 col-sm-6">
              <Skeleton
                variant="rectangular"
                width={"100%"}
                height={200}
                animation="wave"
              />
            </div>
            <div className="col-md-3 col-sm-6">
              <Skeleton
                variant="rectangular"
                width={"100%"}
                height={200}
                animation="wave"
              />
            </div>
            <div className="col-md-3 col-sm-6">
              <Skeleton
                variant="rectangular"
                width={"100%"}
                height={200}
                animation="wave"
              />
            </div>{" "}
          </div>
        )}
        {/* {cards.map((v, i) => (
          <div className="col-3">
            <TariffCard
              key={i}
              name={v.name}
              keywords={v.keywords}
              price={v.price}
              onClick={v.onClick}
            />
          </div>
        ))} */}
      </div>
    </div>
  );
};

export default Tarif;
